define('modules/editor/views/property_boxes/page_jquery_selector',['require','exports','module','./base','common/jquery/config','ldsh!../../templates/property_boxes/page_jquery_selector'],function(require, exports, module){
  "use strict";
  var BasePropertyBox = require("./base"),
      jQueryConfig = require("common/jquery/config");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/page_jquery_selector"),

    helpers: function() {
      return {
        jqueryAvailableVersions: jQueryConfig.availableVersions
      };
    },

    onRender: function() {
      if (!this.model.get('version')) {
        this.$('js-jquery-selector-page')[0].selectedIndex = 0;
        this.$('js-jquery-selector-page').trigger('change');
      }
    }
  });
});

